module.exports = __webpack_public_path__ + "static/img/member_icon_4.5bb41c34.png";